import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Icon } from 'antd';
import styled from 'styled-components';

const ButtonGroup = Button.Group;

const Search = Input.Search;

const StyledOuter = styled.div`
  margin-bottom: 10px;

  button {
    margin-right: 15px;
  }

  p {
    color: black;
    margin-bottom: 5px;
  }
`;

const ChartListFilter = ({
  filter,
  onChange,
  searchText,
  onChangeSearch,
  onCreate,
  createText,
}) => {
  return (
    <StyledOuter>
      <div>
        <Button
          onClick={() => onChange('all')}
          type={filter === 'all' ? 'primary' : 'default'}
        >
          ALL
        </Button>
        <Button
          onClick={() => onChange('mine')}
          type={filter === 'mine' ? 'primary' : 'default'}
        >
          MINE
        </Button>
        <Button
          onClick={() => onChange('favorites')}
          type={filter === 'favorites' ? 'primary' : 'default'}
        >
          FAVORITES
        </Button>
        <Search
          placeholder="Search"
          style={{ width: '250px' }}
          value={searchText}
          onChange={e => onChangeSearch(e.target.value)}
        />
        <ButtonGroup style={{ float: 'right' }}>
          <Button type="primary" onClick={onCreate}>
            <Icon type="plus" />
            {createText}
          </Button>
        </ButtonGroup>
      </div>
    </StyledOuter>
  );
};

ChartListFilter.propTypes = {
  filter: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  onChangeSearch: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  createText: PropTypes.string.isRequired,
};

export default ChartListFilter;



// WEBPACK FOOTER //
// ./src/components/ListFilter/ListFilter.js